export default __webpack_public_path__ + "static/media/villages.3e7ba428.yml";